//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.SelectFeature.js";
import "../no/SelectIBasePlaneList.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CamType",1,0],[0,"CreateScrap",1,0],[0,"EndPlaneSelected",1,0],[0,"FinishOperation",1,0],[0,"LayoutFlange",1,0],[0,"MatchCut",1,0],[0,"SelectCamDirection",1,"Direction",0],[1,"SelectDieTip",0,"Features.SelectFeature",0],[0,"SelectEndPlane",1,"Plane",0],[1,"SelectScrapCutters",0,"SelectIBasePlaneList",0],[0,"SelectStartPlane",1,"Plane",0],[1,"SelectTrimBounds",0,"ScCollector",0],[0,"StartPlaneSelected",1,0],[0,"TrimDirection",1,0],[0,"TrimNewDieFace",1,0],[0,"TrimTolerance",1,0]],[[[],"SwitchTrimSide",{},0,0],[["notchOffset"],"SetMatchCutNotchOffset",{},1,0],[["firstRadius"],"SetMatchCutFirstRadius",{},1,0],[["secondRadius"],"SetMatchCutSecondRadius",{},1,0],[["thirdRadius"],"SetMatchCutThirdRadius",{},1,0],[["offsetLength"],"SetMatchCutOffsetLength",{},1,0],[["angle"],"SetMatchCutAngle",{},1,0],[["scrapCutterLength"],"SetMatchCutScrapCutterLength",{},1,0],[["offsetFromPlane"],"SetMatchCutOffsetFromPlane",{},1,0],[["useOffset"],"SetUsePlaneOffset",{},1,0]],[]];
SPLM.Tooling.DieEngTrimTaskBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DieEngTrimTaskBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.DieEngTrimTaskBuilder.TrimTaskCamType = Object.freeze({
    "AerialCam" : "AerialCam", "BaseMountedCam" : "BaseMountedCam", "Direct" : "Direct"});

SPLM.Tooling.DieEngTrimTaskBuilder.TrimTaskMatchCutType = Object.freeze({
    "None" : "None", "Start" : "Start", "End" : "End", "Both" : "Both"});

export default SPLM;